import { useMemo } from 'react';

export const usePerfTier = () => {
  return useMemo(() => {
    const isMobile =
      window.innerWidth < 768 || window.matchMedia('(pointer: coarse)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return {
      isMobile,
      reduced,
      dpr: isMobile ? [0.75, 1] : [1, 1.5],
      particles: isMobile ? 280 : 900,
    };
  }, []);
};
